import React from 'react';
import { useTranslation } from 'react-i18next';
import { Skeleton } from 'primereact/skeleton';
import CustomTooltip from '../../../../../shared/components/common/tooltip/CustomTooltip';
import EmptyPanel from '../../../../../shared/components/empty-panel/EmptyPanel';
import LineChart from '../../../../../shared/components/chart/line-chart/LineChart';
import FilterBox from '../../../../../shared/components/filter-box/FilterBox';
import './SourceRetrievalChart.scss';
import { FilterItem } from '../../../../../shared/components/filter-box/models/FilterBoxModel';

interface SourceRetrievalChartProps {
  countMatrix: (string | number)[][] | null;
  isLoading: boolean;
  periodFilterItems?: FilterItem[];
}

const SourceRetrievalChart: React.FC<SourceRetrievalChartProps> = ({ countMatrix, isLoading, periodFilterItems }) => {
  const { t } = useTranslation();

  const hasData = !!countMatrix && countMatrix.length > 1;

  return (
    <div className="stats__panel source-retrieval-chart__panel">
      <div className="page-box__title-action">
        <div className="page-box__title page-box__title--flex">
          {t('sourceRetrievalByUrl')}
          <CustomTooltip tooltipText="sourceRetrievalByUrlTooltip" addMargin={false} />
        </div>
        {periodFilterItems && periodFilterItems.length > 0 && (
          <FilterBox items={periodFilterItems} />
        )}
      </div>
      {isLoading ? (
        <div className="stats-box stats-box--without-margin stats-box--chart">
          <div className="stats-box__content">
            <Skeleton className="skeleton--chart">
              <span />
            </Skeleton>
          </div>
        </div>
      ) : !hasData ? (
        <div className="stats-box stats-box--without-margin stats-box--chart stats-box--empty">
          <div className="stats-box__content stats-box__content--empty">
            <EmptyPanel />
          </div>
        </div>
      ) : (
        <div className="stats-box stats-box--without-margin stats-box--chart">
          <div className="stats-box__content source-retrieval-chart__content">
            <LineChart
              firstData={countMatrix}
              headers={countMatrix[0]?.slice(1).map(String)}
              legendType="FLEX_START"
              autoFitYAxis={true}
              minValue={0}
              isMax30={false}
              formatYAsPercentage={false}
              smooth={true}
              legendPosition="bottom"
              legendSize="small"
              chartSizeStyle={{ width: '100%', height: '250px' }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default SourceRetrievalChart;
